export enum MaterialCatalogueColumnsEnum {
  Number = 'number',
  Name = 'name',
  Description = 'description',
  Quantity = 'quantity',
  Unit = 'unit',
  Price = 'price',
}
